// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a {
    color: var(--link);
  }
  
/*BOTTONI*/
  button:disabled {
    background: grey !important;
  }
  .btn-rosso {
    background: rgb(189, 4, 4) !important;
  }
  .btn-standard {
    background: var(--secondario);
    border-radius: 10px !important;
    color: var(--white) !important;
    border: none;
    padding: 7px 15px 7px 15px !important;
  }
  .btn-bluScuro {
    background: var(--bluScuro);
    border-radius: 10 !important;
    color: var(--white);
    border: none;
    padding: 7px 15px 7px 15px;
  }
  .btn-vuotoBluScuro {
    background: transparent;
    border-radius: 10px !important;
    color: var(--bluScuro);
    border: 3px solid var(--bluScuro);
    padding: 7px 15px 7px 15px;
  }
  .btn-verde {
    background: var(--verde);
    border-radius: 10px !important;
    color: var(--white);
    border: 3px solid var(--verde);
    padding: 7px 15px 7px 15px;
  }
  
  .pointer {
    cursor: pointer;
  }
  
  
/*404*/
  .Text-center-template {
    background-color: var(--white);
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: calc(10px + 2vmin);
    color: var(--grigioScuro);
  }
  
/*Template per pagine*/
  .page-template {
    padding-top: 120px;
    background-color: var(--grigioChiaro);
    height: 100%;
    color: var(--grigioScuro);
  }
  .page-template .main-content {
    width:95%;
    max-width: 1400px;
    margin: 0 auto;
  }
  .page-template .titolo-page {
    margin-bottom: 50px;
  }
  
  
  .contenuto-esterno-pagina {
    display: flex;    
  }
  
  .contenuto-esterno-pagina .sidebar-left, .contenuto-esterno-pagina .sidebar-right {
    width: 40%;
  }
  
  .contenuto-esterno-pagina .main-column {
    width: 60%
  }


/*GRID DELLE SCHEDE PER I CONTENUTI DELLE PAGINE*/
.box {
  background: var(--white);
  padding: 20px 30px 20px 30px;
  border-radius: 15px;
  margin-bottom: 30px;
}   
@media only screen and (max-width: 768px) {
.box {
  padding: 20px 10px 20px 10px;
  } 
}
.box1col {
  width: 100%;
}
.box2col {
  display: flex;
  justify-content: space-between;
}
.box2colint {
  width: 49%;
}
@media only screen and (max-width: 900px) { 
  .box2col {
    display: block;
  }
  .box2colint {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/style/Index.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;EACpB;;AAEF,UAAU;EACR;IACE,2BAA2B;EAC7B;EACA;IACE,qCAAqC;EACvC;EACA;IACE,6BAA6B;IAC7B,8BAA8B;IAC9B,8BAA8B;IAC9B,YAAY;IACZ,qCAAqC;EACvC;EACA;IACE,2BAA2B;IAC3B,4BAA4B;IAC5B,mBAAmB;IACnB,YAAY;IACZ,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,8BAA8B;IAC9B,sBAAsB;IACtB,iCAAiC;IACjC,0BAA0B;EAC5B;EACA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;IACnB,8BAA8B;IAC9B,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;;AAGF,MAAM;EACJ;IACE,8BAA8B;IAC9B,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,yBAAyB;EAC3B;;AAEF,sBAAsB;EACpB;IACE,kBAAkB;IAClB,qCAAqC;IACrC,YAAY;IACZ,yBAAyB;EAC3B;EACA;IACE,SAAS;IACT,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;;;EAGA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE;EACF;;;AAGF,iDAAiD;AACjD;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;AACA;EACE,4BAA4B;EAC5B;AACF;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;AACF","sourcesContent":["a {\n    color: var(--link);\n  }\n  \n/*BOTTONI*/\n  button:disabled {\n    background: grey !important;\n  }\n  .btn-rosso {\n    background: rgb(189, 4, 4) !important;\n  }\n  .btn-standard {\n    background: var(--secondario);\n    border-radius: 10px !important;\n    color: var(--white) !important;\n    border: none;\n    padding: 7px 15px 7px 15px !important;\n  }\n  .btn-bluScuro {\n    background: var(--bluScuro);\n    border-radius: 10 !important;\n    color: var(--white);\n    border: none;\n    padding: 7px 15px 7px 15px;\n  }\n  .btn-vuotoBluScuro {\n    background: transparent;\n    border-radius: 10px !important;\n    color: var(--bluScuro);\n    border: 3px solid var(--bluScuro);\n    padding: 7px 15px 7px 15px;\n  }\n  .btn-verde {\n    background: var(--verde);\n    border-radius: 10px !important;\n    color: var(--white);\n    border: 3px solid var(--verde);\n    padding: 7px 15px 7px 15px;\n  }\n  \n  .pointer {\n    cursor: pointer;\n  }\n  \n  \n/*404*/\n  .Text-center-template {\n    background-color: var(--white);\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    font-size: calc(10px + 2vmin);\n    color: var(--grigioScuro);\n  }\n  \n/*Template per pagine*/\n  .page-template {\n    padding-top: 120px;\n    background-color: var(--grigioChiaro);\n    height: 100%;\n    color: var(--grigioScuro);\n  }\n  .page-template .main-content {\n    width:95%;\n    max-width: 1400px;\n    margin: 0 auto;\n  }\n  .page-template .titolo-page {\n    margin-bottom: 50px;\n  }\n  \n  \n  .contenuto-esterno-pagina {\n    display: flex;    \n  }\n  \n  .contenuto-esterno-pagina .sidebar-left, .contenuto-esterno-pagina .sidebar-right {\n    width: 40%;\n  }\n  \n  .contenuto-esterno-pagina .main-column {\n    width: 60%\n  }\n\n\n/*GRID DELLE SCHEDE PER I CONTENUTI DELLE PAGINE*/\n.box {\n  background: var(--white);\n  padding: 20px 30px 20px 30px;\n  border-radius: 15px;\n  margin-bottom: 30px;\n}   \n@media only screen and (max-width: 768px) {\n.box {\n  padding: 20px 10px 20px 10px;\n  } \n}\n.box1col {\n  width: 100%;\n}\n.box2col {\n  display: flex;\n  justify-content: space-between;\n}\n.box2colint {\n  width: 49%;\n}\n@media only screen and (max-width: 900px) { \n  .box2col {\n    display: block;\n  }\n  .box2colint {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
